import { useState, useEffect, useRef } from 'react'
import {
  FeatureHintDef,
  getHintForTab,
  markHintSeen,
  resetAllHints,
} from '../data/featureHints'
export function useFeatureHints(activeTab: string) {
  const [activeHint, setActiveHint] = useState<FeatureHintDef | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const autoDismissRef = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    // Clear any existing timeouts when tab changes
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    if (autoDismissRef.current) clearTimeout(autoDismissRef.current)
    setActiveHint(null)
    const hint = getHintForTab(activeTab)
    if (hint) {
      const delay = hint.delay || 1000
      timeoutRef.current = setTimeout(() => {
        setActiveHint(hint)

        // Setup auto-dismiss
        const autoDismissTime = hint.autoDismiss || 8000
        autoDismissRef.current = setTimeout(() => {
          dismissHint(hint.id)
        }, autoDismissTime)
      }, delay)
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      if (autoDismissRef.current) clearTimeout(autoDismissRef.current)
    }
  }, [activeTab])
  const dismissHint = (id?: string) => {
    const hintId = id || activeHint?.id
    if (hintId) {
      markHintSeen(hintId)
    }
    setActiveHint(null)
    if (autoDismissRef.current) clearTimeout(autoDismissRef.current)
  }
  return {
    activeHint,
    dismissHint,
    resetAll: () => {
      resetAllHints()
      setActiveHint(null)
    },
  }
}
